import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faNodeJs, faJs, faJava, faLinux } from '@fortawesome/free-brands-svg-icons';
import '../assets/styles/Skils.scss';

const techSkills = [
  { name: "JavaScript", icon: faJs, level: 65 },
  { name: "React", icon: faReact, level: 40 },
  { name: "Node.js", icon: faNodeJs, level: 50 },
  { name: "Java", icon: faJava, level: 75 },
  { name: "Linux / CLI", icon: faLinux, level: 45 },
];

function TechSkillsGrid() {
  return (
    <div id='skills'>
        <div className="tech-grid-container">
            <h2 className="tech-title">Tecnologies</h2>
            <div className="tech-grid">
                {techSkills.map((skill, index) => (
                <div key={index} className="tech-card">
                    <FontAwesomeIcon icon={skill.icon} size="3x" />
                    <h4>{skill.name}</h4>
                    <div className="progress-bar">
                    <div className="progress" style={{ width: `${skill.level}%` }}></div>
                    </div>
                    <span className="progress-label">{skill.level}% proficiency</span>
                </div>
                ))}
            </div>
        </div>
    </div>
  );
}

export default TechSkillsGrid;
